export default "__VITE_ASSET__bc08ea77__"